export default __webpack_public_path__ + "static/media/Philosophie.1ae98983.png";